(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();

/* LaCucu: background follows the active enlarged gallery image. */
(() => {
  if (window.lcAmbientGalleryInstalled) return;
  window.lcAmbientGalleryInstalled = true;
  const instances = new Map();
  function attach(modal) {
    if (instances.has(modal)) return;
    let pending = 0;
    let lastUrl = '';
    function update() {
      pending = 0;
      if (!modal.hasAttribute('open')) return;
      const slider = modal.querySelector('.js-popup-slider');
      const active = slider?.querySelector('.swiper-slide-active') ||
        (slider?.swiper && slider.swiper.slides[slider.swiper.activeIndex]);
      const openerId = modal.openedBy?.getAttribute('data-media-id');
      const slides = [...modal.querySelectorAll('[data-media-modal-id]')];
      const slide = active || slides.find(item => item.dataset.mediaModalId.endsWith(`-${openerId}`)) || slides[0];
      const url = slide?.dataset.lcAmbient || '';
      if (url === lastUrl) return;
      lastUrl = url;
      const dialog = modal.querySelector('.product-media-modal__dialog');
      if (!dialog) return;
      dialog.style.setProperty('--lc-ambient-image', url ? `url(${JSON.stringify(url)})` : 'none');
      modal.classList.toggle('lc-ambient-gallery', Boolean(url));
    }
    const schedule = () => { if (!pending) pending = requestAnimationFrame(update); };
    const observer = new MutationObserver(schedule);
    observer.observe(modal, { subtree: true, attributes: true, attributeFilter: ['class', 'open'], childList: true });
    modal.addEventListener('load', schedule, true);
    instances.set(modal, { observer, schedule, cleanup() {
      observer.disconnect();
      cancelAnimationFrame(pending);
      modal.removeEventListener('load', schedule, true);
    } });
    schedule();
  }
  function scan() {
    for (const [modal, state] of instances) {
      if (!modal.isConnected) { state.cleanup(); instances.delete(modal); }
    }
    document.querySelectorAll('product-modal.product-media-modal').forEach(attach);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(scan));
})();
